/*
 * Copyright (c) 2019
 * Company: G-Portal
 * Filename: voiceserver.ts
 * Class: voiceserver.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */


import { Server } from '../../../units/server/server';
import ServerInterface = Server.ServerInterface;
import ServerOptions = Server.ServerOptions;
import { IPromise } from 'q';
import GameServerQueryResponse = Server.GameServerQueryResponse;
import VoiceServerQueryResponse = Server.VoiceServerQueryResponse;

export class Voiceserver {
    protected readonly QUERY_TIMER : number = 5000;
    protected readonly PLAYER_SELECTOR : string = '.voiceserver .voiceserver__current__players';
    public static readonly BASE_SELECTOR : string = '.voiceserver';
    
    /**
     *
     * @param server {ServerInterface}
     */
    constructor(private server : ServerInterface) {
        server.options = new ServerOptions(true, this.QUERY_TIMER);
        server.options.queryEvent.addEventListener(Server.ServerEventType.SERVERQUERY_EVENT, (queryResponse: Promise<VoiceServerQueryResponse>) => {
            this.updatePlayers(queryResponse);
        });
    }
    
    /**
     *
     * @param queryResponse {Promise<VoiceServerQueryResponse>}
     */
    private updatePlayers(queryResponse: Promise<VoiceServerQueryResponse>): void {
        queryResponse
            .then((queryResponse : Server.VoiceServerQueryResponse) => {
                $(this.PLAYER_SELECTOR).text(queryResponse.online.toString());
            })
            .catch((error) => {
                console.error(error);
            });
    }
}

export function initVoiceserver() {
    if($(Voiceserver.BASE_SELECTOR).length) {
        if(Server.ServerUnit.hasGameservers() && Server.ServerUnit.getActiveServer() !== null) {
            if(Server.ServerUnit.getActiveServer().type === Server.ServerType.VOICESERVER) {
                let voiceserver : Voiceserver = new Voiceserver(Server.ServerUnit.getActiveServer());
            }
        }
    }
}